import ProjectSectionType from 'src/enums/companyProjects/ProjectSectionType';

export const ProjectEndpoints = {
  projectContainerEmail: {
    containerSend: '/api/ProjectContainerEmail/container/send',
    inboxSend: '/api/ProjectContainerEmail/inbox/send'
  },
  projectContainers: {
    create: '/api/ProjectContainers',
    detail: (id: number) => `/api/ProjectContainers/${id}`,
    edit: (id: number) => `/api/ProjectContainers/${id}/edit`,
    intakes: (id: number) => `/api/ProjectContainers/${id}/intakes`,
    overview: (id: number) => `/api/ProjectContainers/${id}/overview`,
    companyView: (id: number) => `/api/ProjectContainers/${id}/companyView`,
    bid: (id: number) => `/api/ProjectContainers/${id}/bid`,
    filteredListPost: (page: number, pageSize: number, orderBy: string | undefined, isDesc: boolean | undefined) => {
      let toReturn = `/api/ProjectContainers/filter?page=${page}&pageSize=${pageSize}`;
      if (orderBy !== undefined) {
        toReturn += `&orderBy=${orderBy}`;
      }
      if (isDesc !== undefined) {
        toReturn += `&isDesc=${isDesc}`;
      }
      return toReturn;
    }
  },
  projectDashboard: {
    myContainers: '/api/projectDashboard/my-containers'
  },
  projectFolders: {
    create: '/api/project-folders',
    edit: (folderId: number) => `/api/project-folders/${folderId}`
  },
  projectHotels: {
    base: (containerId: number) => `/api/project-containers/${containerId}/hotels`,
    city: (containerId: number, projectHotelCityId: number) =>
      `/api/project-containers/${containerId}/hotels/cities/${projectHotelCityId}`,
    cityHotels: (containerId: number, projectHotelCityId: number) =>
      `/api/project-containers/${containerId}/hotels/cities/${projectHotelCityId}/hotels`,
    disableCity: (containerId: number, projectHotelCityId: number) =>
      `/api/project-containers/${containerId}/hotels/cities/${projectHotelCityId}/disable`,
    enableCity: (containerId: number, projectHotelCityId: number) =>
      `/api/project-containers/${containerId}/hotels/cities/${projectHotelCityId}/enable`,
    removeCity: (containerId: number, projectHotelCityId: number) =>
      `/api/project-containers/${containerId}/hotels/cities/${projectHotelCityId}`,
    hotel: (containerId: number, projectHotelId: number) =>
      `/api/project-containers/${containerId}/hotels/hotels/${projectHotelId}`,
    archiveHotel: (containerId: number, projectHotelId: number) =>
      `/api/project-containers/${containerId}/hotels/hotels/${projectHotelId}/archive`,
    disableHotel: (containerId: number, projectHotelId: number) =>
      `/api/project-containers/${containerId}/hotels/hotels/${projectHotelId}/disable`,
    enableHotel: (containerId: number, projectHotelId: number) =>
      `/api/project-containers/${containerId}/hotels/hotels/${projectHotelId}/enable`,
    removeHotel: (containerId: number, projectHotelId: number) =>
      `/api/project-containers/${containerId}/hotels/hotels/${projectHotelId}`,
    hotelAvailableRates: (containerId: number, projectHotelId: number) =>
      `/api/project-containers/${containerId}/hotels/hotels/${projectHotelId}/available-rates`,
    hotelContracts: (containerId: number, projectHotelId: number) =>
      `/api/project-containers/${containerId}/hotels/hotels/${projectHotelId}/contracts`,
    hotelEmail: (containerId: number, projectHotelId: number) =>
      `/api/project-containers/${containerId}/hotels/hotels/${projectHotelId}/email`,
    hotelSelectedRates: (containerId: number, projectHotelId: number) =>
      `/api/project-containers/${containerId}/hotels/hotels/${projectHotelId}/selected-rates`,
    archiveSelectedRate: (containerId: number, projectHotelSelectedRateId: number) =>
      `/api/project-containers/${containerId}/hotels/selected-rates/${projectHotelSelectedRateId}/archive`,
    roomType: (containerId: number, projectHotelRoomTypeId: number) =>
      `/api/project-containers/${containerId}/hotels/room-types/${projectHotelRoomTypeId}`,
    archiveRoomType: (containerId: number, projectHotelRoomTypeId: number) =>
      `/api/project-containers/${containerId}/hotels/room-types/${projectHotelRoomTypeId}/archive`,
    unarchiveRoomType: (containerId: number, projectHotelRoomTypeId: number) =>
      `/api/project-containers/${containerId}/hotels/room-types/${projectHotelRoomTypeId}/unarchive`,
    removeRoomType: (containerId: number, projectHotelRoomTypeId: number) =>
      `/api/project-containers/${containerId}/hotels/room-types/${projectHotelRoomTypeId}`,
    roomTypeRates: (containerId: number, projectHotelRoomTypeId: number) =>
      `/api/project-containers/${containerId}/hotels/room-types/${projectHotelRoomTypeId}/rates`,
    rate: (containerId: number, projectHotelRateId: number) =>
      `/api/project-containers/${containerId}/hotels/rates/${projectHotelRateId}`,
    archiveRate: (containerId: number, projectHotelRateId: number) =>
      `/api/project-containers/${containerId}/hotels/rates/${projectHotelRateId}/archive`,
    unarchiveRate: (containerId: number, projectHotelRateId: number) =>
      `/api/project-containers/${containerId}/hotels/rates/${projectHotelRateId}/unarchive`,
    removeRate: (containerId: number, projectHotelRateId: number) =>
      `/api/project-containers/${containerId}/hotels/rates/${projectHotelRateId}`,
    mapCities: (containerId: number, provinceId: number) =>
      `/api/project-containers/${containerId}/hotels/map/cities?provinceId=${provinceId}`,
    mapHotels: (containerId: number, cityId: number, radiusKm: number = 50) =>
      `/api/project-containers/${containerId}/hotels/map/hotels?cityId=${cityId}&radiusKm=${radiusKm}`
  },
  projectIntake: {
    inbox: '/api/ProjectIntake/inbox',
    detail: (intakeId: number) => `/api/ProjectIntake/${intakeId}`,
    updateSubject: (intakeId: number) => `/api/ProjectIntake/${intakeId}/subject`,
    utility: {
      assignToContainer: (projectId: number) => `/api/ProjectIntake/${projectId}/utility/assignToContainer`,
      delete: (projectId: number) => `/api/ProjectIntake/${projectId}/utility/delete`,
      merge: (projectId: number, destinationProjectIntakeId: number) =>
        `/api/ProjectIntake/${projectId}/utility/merge?destinationProjectIntakeId=${destinationProjectIntakeId}`,
      search: (projectId: number) => `/api/ProjectIntake/${projectId}/utility/search`,
      send: (projectId: number) => `/api/ProjectIntake/${projectId}/utility/send`
    }
  },
  projectSections: {
    section: (containerId: number, sectionType: ProjectSectionType) =>
      `/api/project-sections/${containerId}/${sectionType}`,
    homeFeed: (containerId: number) => `/api/project-sections/${containerId}/home`,
    create: (containerId: number) => `/api/project-sections/${containerId}/createIntake`,
    remove: (intakeId: number) => `/api/project-sections/${intakeId}/removeIntake`,
    move: (intakeId: number) => `/api/project-sections/${intakeId}/moveIntake`,
    updateIntake: (intakeId: number) => `/api/project-sections/${intakeId}/updateIntake`,
    markIntakeRead: (intakeId: number) => `/api/project-sections/${intakeId}/mark-intake-read`
  }
};
